/* eslint-disable */
import {
  IHttpApi,
  mergeBaseUri,
  mergePaths,
  transformObjectToQuery,
  IHTTPRequestConfig,
  IHTTPCompletedResponse,
  ContentDataType,
} from '@cian/http-api';

import { IAddLikeRequest, IAddLikeConfig, TResponses } from './types';

const defaultConfig: Required<IAddLikeConfig> = {
  pathApi: '/v1/add-like',
  browserUrl: 'https://dev-cian.ru/content-api',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const defaultRequest: IHTTPRequestConfig<any> = {
  uri: {
    host: '',
    path: '',
  },
  method: 'POST',
  requestType: 'formData',
  body: '',
  withCredentials: true,
  headers: [['Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8']],
  responseContentType: ContentDataType.Json,
};

function createAddLikeRequest({
  bodyParameters,
  config,
}: Pick<IAddLikeOptions, 'bodyParameters' | 'config'>): IHTTPRequestConfig<any> {
  const { pathApi, browserUrl } = { ...defaultConfig, ...config };

  return {
    ...defaultRequest,
    uri: mergeBaseUri(browserUrl, {
      path: (path: string) => mergePaths(path, pathApi),
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body: transformObjectToQuery(bodyParameters as any).unwrap() as any,
  };
}

export interface IAddLikeOptions {
  httpApi: IHttpApi;
  bodyParameters: IAddLikeRequest;
  config?: IAddLikeConfig;
}

async function fetchAddLike({
  httpApi,
  bodyParameters,
  config,
}: IAddLikeOptions): Promise<IHTTPCompletedResponse<TResponses>> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return httpApi.httpRequest(createAddLikeRequest({ bodyParameters, config })) as any;
}

export { defaultConfig, createAddLikeRequest, fetchAddLike };
